// extracted by mini-css-extract-plugin
export default {"status":"EmailStatus_status__XHBLM","progress":"EmailStatus_progress__NX05f"};